import { SEO } from "gatsby-theme-core";
import React from "react";
import PropTypes from "prop-types";
import { graphql } from "gatsby";
import { normalizedData } from "@streamo/helper/methods";
import { Layout, HeaderOne, FooterOne } from "gatsby-theme-layout";
import {
    LoginRegisterTabDark,
    PageHeader01,
    LoginTabContent01Dark,
    RegisterTabContent02Dark,
} from "gatsby-theme-container";

const FAQPage = ({ data }) => {
    const content = normalizedData(data?.page?.content || []);
    return (
        <Layout>
            <SEO pageName="Login And Register" />
            <HeaderOne data={{ ...data?.header, ...data.navigation }} />
            <PageHeader01 data={content?.["page-header-section"]} />
            <LoginRegisterTabDark>
                <LoginTabContent01Dark data={content?.["login-section"]} />
                <RegisterTabContent02Dark
                    data={content?.["register-section"]}
                />
            </LoginRegisterTabDark>
            <FooterOne data={{ ...data?.footer, ...data?.contact }} />
        </Layout>
    );
};

export const query = graphql`
    query LoginRegisterTwoPageQuery {
        header: general(section: { eq: "header-01" }) {
            ...Header01
        }
        navigation: general(section: { eq: "menu-streaming" }) {
            ...Menu01
        }
        footer: general(section: { eq: "footer-01" }) {
            ...Footer01
        }
        contact: general(section: { eq: "contact" }) {
            ...Contact01
        }
        page(title: { eq: "login-register" }) {
            content {
                ...PageContent
            }
        }
    }
`;
FAQPage.propTypes = {
    data: PropTypes.shape({
        header: PropTypes.shape({}),
        navigation: PropTypes.shape({}),
        footer: PropTypes.shape({}),
        contact: PropTypes.shape({}),
        page: PropTypes.shape({
            content: PropTypes.arrayOf(PropTypes.shape({})),
        }),
    }),
};

export default FAQPage;
